import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isReady: false,
    subject: null,
    to: [],
    cc: [],
    bcc: []
  },
  mutations: {
    ['INITIALIZE'](state) {
      state.isReady = false;
      state.subject = null;
      state.to = [];
      state.cc = [];
      state.bcc = [];
    },
    ['UPDATE'](state, { subject, to, cc, bcc }) {
      state.isReady = true;
      state.subject = subject;
      state.to = to;
      state.cc = cc;
      state.bcc = bcc;
    }
  },
  actions: {
    initialize({ commit }) {
      commit('INITIALIZE');
    },
    update({ commit }, { subject, to, cc, bcc }) {
      commit('UPDATE', { subject, to, cc, bcc });
    }
  },
  modules: {}
});
